import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { toggleClass } from '../utils/dom'

const STATES = {
    ACTIVE: 'is-active'
}

export default class PlanFloorControls extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            badge: null
        }

        this.floorId = this.element.dataset.floor
    }

    prepare() {
        EventBus.on('plan:filter:change', this.handlePlanFilterChange)
        EventBus.on('plan:filter:reset', this.handlePlanFilterReset)
    }

    handlePlanFilterChange = ({ floors = {} }) => {
        if (!(this.floorId in floors)) {
            return
        }

        this.ref.badge.textContent = floors[this.floorId]
        toggleClass(this.ref.badge, STATES.ACTIVE, floors[this.floorId] > 0)

    }

    handlePlanFilterReset = () => {
        this.ref.badge.classList.remove(STATES.ACTIVE)
    }

}